/* global TimelineLite TweenLite Power1 */
var THREE = (typeof window !== "undefined" ? window['THREE'] : typeof global !== "undefined" ? global['THREE'] : null);
const timing = require('./timing');
const timingRecorder ={};
THREE.PanControls = function (object, domElement) {
    domElement = (domElement !== undefined) ? domElement : document;

    // API
    this.soften = null;
    this.moving = false;
    this.enabled = true;
    this.firstrun = false;
    this.center = new THREE.Vector3();
    this.panSpeed = 0.001;
  
    this.timeline = new TimelineLite({
        onUpdate: function() {
            //timingRecorder[Math.floor(object.position.x)] = this.time();
        },
        onComplete:function() {
            this.restart();
        }});
    
    this.timeline.pause();

    this.velocity = 0;
    
    //-1180 - 820
    this.max = 820;
    this.min = -1200;
    const camera = {
        x : this.min,
    };

    const right = {
        x : this.max,
        ease:Power1.easeInOut,
        onUpdate() {
            object.position.x = camera.x;
        },
    };
    const left = {
        x : this.min,
        ease:Power1.easeInOut,
        onUpdate() {
            object.position.x = camera.x;
        },
    };
    
    this.timeline.add( TweenLite.to(camera, 28, right) );
    this.timeline.add( TweenLite.to(camera, 28, left) );
    
    
    // internals

    const that = this;

    
    

    const delta = new THREE.Vector3();

    const STATE = { NONE: - 1, PAN: 0 };
    let state = STATE.NONE;

    const {center} = this;
    const normalMatrix = new THREE.Matrix3();
    const pointer = new THREE.Vector2();
    const pointerOld = new THREE.Vector2();

    // events

    const changeEvent = { type: 'change' };
    let position = 0;
    let restartTimeout;

    this.play = function() {
        that.moving = true;
        that.timeline.play();
    }

    this.pause = function() {
        that.timeline.pause();
    }

    this.slowdown = function(){
        if(!that.timeline.paused()){
            that.timeline.pause();
            const camera = {
                x : object.position.x,
            };
            const direction = that.timeline.time() > 26 ? -25 : 25;
            let end = object.position.x + direction;
            if(end > that.max){
                end = that.max
            }
            if(end < that.min){
                end = that.min
            }
            const soft = {
                x : end,
                ease:Power1.easeOut,
                onUpdate() {
                    object.position.x = camera.x;
                },
            };
            that.soften = TweenLite.to(camera, 1, soft);
        }
    }

    this.resume = function(time = 6000, customtime = false) {
        if(restartTimeout){
            clearTimeout(restartTimeout);
        }
        
        restartTimeout= setTimeout(() => {
            if(state = STATE.NONE && that.enabled && this.firstrun){
                that.moving = true;
                let distance = 9999;
                let time = 0;
                if(customtime !== false){
                    time = timing["-1175"];
                } else {
                    Object.keys(timing).forEach((position) => {
                        const currentdistance = Math.abs(object.position.x - position);
                        if(currentdistance<distance){
                            distance = currentdistance;
                            time = timing[position];
                        }
                    });
                }
                that.timeline.time(time);
                that.timeline.play();
            }
        }, time);
    }

    this.pan = function (delta) {
        const distance = object.position.distanceTo(center);
        delta.multiplyScalar(distance * that.panSpeed);
        delta.applyMatrix3(normalMatrix.getNormalMatrix(object.matrix));

        if(object.position.x > this.max && delta.x > 0){
            this.velocity = 0;
            return;
        }
        if(object.position.x < this.min && delta.x < 0){
            this.velocity = 0;
            return;
        }
        this.velocity = delta.x;
        that.moving = true;
        object.position.add(delta);
        center.add(delta);

        position = (object.position.x + 1100) / 1920 * 26;

        that.dispatchEvent(changeEvent);
    };

    // mouse

    const onTouchStart = function(event) {
        if(that.soften){
            that.soften.kill();
        }
        if (that.enabled === false) return;

        const touches = event.changedTouches;
      
        if (touches.length > 0){
            that.timeline.pause();
            state = STATE.PAN;
            that.moving = true;

            domElement.parentNode.classList.add('panning');
            pointerOld.set(touches[0].clientX, touches[0].clientY);

            domElement.addEventListener('mousemove', onMouseMove, false);
            domElement.addEventListener('touchmove', onTouchMove, false);
            domElement.addEventListener('mouseup', onMouseUp, false);
            domElement.addEventListener('touchend', onMouseUp, false);
            domElement.addEventListener('touchcancel', onMouseUp, false);
            domElement.addEventListener('mouseout', onMouseUp, false);
            domElement.addEventListener('dblclick', onMouseUp, false);
        }
    };

    const onMouseDown = function(event) {
        if(that.soften){
            that.soften.kill();
        }
        if (that.enabled === false) return;

        if (event.button === 0) {
            that.timeline.pause();
            state = STATE.PAN;
            that.moving = true;
        }

        domElement.parentNode.classList.add('panning');

        pointerOld.set(event.clientX, event.clientY);

        domElement.addEventListener('mousemove', onMouseMove, false);
        domElement.addEventListener('touchmove', onTouchMove, false);
        domElement.addEventListener('mouseup', onMouseUp, false);
        domElement.addEventListener('touchend', onMouseUp, false);
        domElement.addEventListener('touchcancel', onMouseUp, false);
        domElement.addEventListener('mouseout', onMouseUp, false);
        domElement.addEventListener('dblclick', onMouseUp, false);
    };

    const onMouseMove = function(event) {
        if (that.enabled === false) return;

        pointer.set(event.clientX, event.clientY);

        const movementX = pointer.x - pointerOld.x;

        if (state === STATE.PAN) {
            that.pan(delta.set(- movementX, 0, 0));
        }

        pointerOld.set(event.clientX, event.clientY);
    };

    const onTouchMove = function(event) {
        if (that.enabled === false) return;

        const touches = event.changedTouches;
      
        if (touches.length > 0){
            pointer.set(touches[0].clientX, touches[0].clientY);

            const movementX = pointer.x - pointerOld.x;

            if (state === STATE.PAN) {
                that.pan(delta.set(- movementX, 0, 0));
            }

            pointerOld.set(touches[0].clientX, touches[0].clientY);
        }
    };

    const onMouseUp = function() {
        domElement.removeEventListener('mousemove', onMouseMove, false);
        domElement.removeEventListener('touchmove', onTouchMove, false);
        domElement.removeEventListener('mouseup', onMouseUp, false);
        domElement.removeEventListener('touchend', onMouseUp, false);
        domElement.removeEventListener('touchcancel', onMouseUp, false);
        domElement.removeEventListener('mouseout', onMouseUp, false);
        domElement.removeEventListener('dblclick', onMouseUp, false);
        domElement.parentNode.classList.remove('panning');
        
        if(that.velocity && that.velocity !== 0){
            const camera = {
                x : object.position.x,
            };
            let end = object.position.x + (that.velocity*10);
            if(end > that.max){
                end = that.max
            }
            if(end < that.min){
                end = that.min
            }
            const soft = {
                x : end,
                ease:Power1.easeOut,
                onUpdate() {
                    object.position.x = camera.x;
                },
            };
            that.soften = TweenLite.to(camera, 1, soft);
        }
        state = STATE.NONE;
        that.resume();
        /*setTimeout(() => {
            that.moving = false;
        },200);
        */
    };

    const contextmenu = function(event) {
        event.preventDefault();
    };

    this.dispose = function () {
        domElement.removeEventListener('contextmenu', contextmenu, false);
        domElement.removeEventListener('mousedown', onMouseDown, false);
        domElement.removeEventListener('touchstart', onTouchStart, false);

        domElement.removeEventListener('mousemove', onMouseMove, false);
        domElement.removeEventListener('touchmove', onTouchMove, false);
        domElement.removeEventListener('mouseup', onMouseUp, false);
        domElement.removeEventListener('touchend', onMouseUp, false);
        domElement.removeEventListener('touchcancel', onMouseUp, false);
        domElement.removeEventListener('mouseout', onMouseUp, false);
        domElement.removeEventListener('dblclick', onMouseUp, false);
    };

    domElement.addEventListener('contextmenu', contextmenu, false);
    domElement.addEventListener('mousedown', onMouseDown, false);
    domElement.addEventListener('touchstart', onTouchStart, false);
};

THREE.PanControls.prototype = Object.create(THREE.EventDispatcher.prototype);
THREE.PanControls.prototype.constructor = THREE.PanControls;
